import { createRoot } from "react-dom/client";
import App from "./App";
import "../style.css";

const rootElement = document.querySelector<HTMLDivElement>("#root");

if (!rootElement) {
  throw new Error("Contenitore #root non trovato");
}

createRoot(rootElement).render(<App />);
